import { Box, Button, Typography } from '@mui/material';
import React, { ReactElement, useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import './Report.css';
import WaybillReportContent from './WaybillReportContent';
import { WarehouseClient } from '../../api/Extensions';
import { WaybillFullInfoDto } from '../../api/ClientApi';
import { useAppSelector } from '../../hooks/hooks';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export default function WaybillReport(): ReactElement {
    const [waybillInfo, setWaybillInfo] = useState<WaybillFullInfoDto | undefined>(undefined);

    const { waybillId } = useParams();

    const companyDetails = useAppSelector((state) => state.companyDetails.companyDetails);

    useEffect(() => {
        if (!!waybillId && !isNaN(+waybillId) && +waybillId > 0) {
            WarehouseClient.getFullWaybillInfo(+waybillId).then((res) => {
                setWaybillInfo(res);
            });
        }
    }, [waybillId]);

    const componentRef = useRef(null);

    const handleAfterPrint = React.useCallback(() => {
        console.log('`onAfterPrint` called');
    }, []);

    const handleBeforePrint = React.useCallback(() => {
        console.log('`onBeforePrint` called');
        return Promise.resolve();
    }, []);

    const reactToPrintFn = useReactToPrint({
        contentRef: componentRef,
        documentTitle: 'Otpremnica',
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint,
    });

    if (waybillInfo === undefined) {
        return <>Currently waiting for miracle...</>;
    }

    return !!companyDetails ? (
        <div className="waybill-report-container">
            <Button variant="contained" color="primary" style={{ marginTop: 10 }} onClick={() => reactToPrintFn()}>
                Odštampaj
            </Button>
            <div className="waybill-report-scroll">
                <div>
                    <WaybillReportContent ref={componentRef} waybillInfo={waybillInfo ?? {}} isInternalWaybill={true} />
                </div>
            </div>
        </div>
    ) : (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100vw',
                height: 'calc(100vh - 120px)',
                textAlign: 'center',
            }}
        >
            <Typography variant="h5" component="h5" sx={{ width: '50vw' }}>
                Informacije o firmi nisu pronađene.
            </Typography>
            <Typography variant="h5" component="h5" sx={{ width: '50vw' }}>
                Unesite neophodne podatke u podešavanjima ({<MoreVertIcon />} u gornjem desnom uglu), ili se obratite
                ovlašćenom licu (Sistemski administrator).
            </Typography>
        </Box>
    );
}
